import { AddressModel } from "models/shared/AddressModel";
import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import React from "react";

export interface IOrganizationModel extends IGenericBaseModel {
    uuid?: string;
    level: number;
    dateCreated?: string;
    dateModified?: string;
    isActive?: boolean;
    name: string;
    fullName?: string;
    address?: AddressModel;
    parent?: OrganizationModel;
    children?: OrganizationModel[];
}

export class OrganizationModel implements IOrganizationModel {
    uuid?: string;
    key?: React.Key;
    level: number;
    dateCreated?: string;
    dateModified?: string;
    isActive?: boolean;
    name: string;
    fullName?: string;
    address?: AddressModel;
    parent?: OrganizationModel;
    childrenOrganizations: OrganizationModel[] = [];

    constructor(data: IOrganizationModel) {
        this.uuid = data?.uuid;
        this.key = data?.uuid;
        this.level = data?.level;
        this.dateCreated = data?.dateCreated;
        this.dateModified = data?.dateModified;
        this.isActive = data?.isActive ?? true;
        this.name = data?.name ?? '';
        this.fullName = data?.fullName ?? '';
        if (data?.address)
            this.address = new AddressModel(data.address);
        if (typeof data?.parent === 'object')
            this.parent = new OrganizationModel(data.parent);
        if (data?.children)
            this.childrenOrganizations = data.children.map(i => new OrganizationModel(i));
    }
}




